import React from 'react';

import { flagStyles } from '../settings';

const SvgTO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-5304px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgTO;
